import env from "Consts/env";
import { handle498OnClient } from "Helpers/is498";
import { ArrayCheck } from "Helpers/checkArray";
import { apiSlice } from "../api/apiSlice";

export const addressApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		loadAddress: builder.query({
			query: (params) => ({
				url: "/api/fds-address",
				headers: {
					...env.HEADERS,
					...params?.headers,
				},
				params: {
					...params,
				},
				validateStatus: (response) => response.status === 304
					|| (response.status >= 200 && response.status < 300)
				,
			}),
			transformResponse: (response) => {

				// Periksa apakah ada kode status 498
				if (response?.meta?.code && response.meta.code === 498) {

					handle498OnClient(response); // Jalankan handler
					return null; // Atau data default jika login diperlukan

				}

				// Sort data address berdasarkan default_shipping
				const dataAddressSort = ArrayCheck(response?.data) && response?.data?.slice().sort(
					(a, b) => b.default_shipping - a.default_shipping,
				);

				// Update data address sort berdasarkan default_shipping dan default_billing
				const updatedDataAddressSort = dataAddressSort.map((item) => ({
					...item,
					selected: item.default_shipping && item.default_billing,
				}));

				// Set address Selected
				const addressDefault = updatedDataAddressSort.find((address) => address.selected);

				// Jika bukan 498, teruskan respons normal
				return {
					status: response?.status ?? response.meta.code,
					data: updatedDataAddressSort,
					currentSelected: addressDefault,
				};

			},
			providesTags: ["Address"],
		}),
		deleteAddress: builder.mutation({
			query: (params) => ({
				url: `/api/fds-address/${params.id}`,
				method: "DELETE",
				headers: {
					...env.HEADERS,
					...params?.headers,
				},
			}),
			transformResponse: (response) => {

				// Periksa apakah ada kode status 498
				if (response?.meta?.code && response.meta.code === 498) {

					handle498OnClient(response); // Jalankan handler
					return null; // Atau data default jika login diperlukan

				}

				return response;

			},
			invalidatesTags: ["Address"],
		}),
		createAddress: builder.mutation({
			query: (body) => ({
				url: "/api/fds-address",
				method: "POST",
				body,
				headers: {
					...env.HEADERS,
				},
			}),
			transformResponse: (response) => {

				// Periksa apakah ada kode status 498
				if (response?.meta?.code && response.meta.code === 498) {

					handle498OnClient(response); // Jalankan handler
					return null; // Atau data default jika login diperlukan

				}

				return response;

			},
			invalidatesTags: ["Address"],
		}),
		updateAddress: builder.mutation({
			query: (body) => ({
				url: `/api/fds-address/${body.id}`,
				method: "PUT",
				body,
				headers: {
					...env.HEADERS,
				},
			}),
			transformResponse: (response) => {

				// Periksa apakah ada kode status 498
				if (response?.meta?.code && response.meta.code === 498) {

					handle498OnClient(response); // Jalankan handler
					return null; // Atau data default jika login diperlukan

				}

				return response;

			},
			invalidatesTags: ["Address"],
		}),
		getRegionWithSelect: builder.query({
			query: (params) => ({
				url: `/api/region/${params.region}?${params.code ? `code=${params.code}` : ""}`,
				headers: {
					...env.HEADERS,
				},
				validateStatus: (response) => response.status === 304
					|| (response.status >= 200 && response.status < 300)
				,
			}),
			transformResponse: (response) => {

				const transformRes = {
					status: response?.code,
					data: response?.body?.data,
				};

				return transformRes;

			},
			providesTags: (result) => (result
				? [...result.data.map(({ code }) => ({ type: "REGION", code })), "REGION"]
				: ["REGION"]),
		}),
	}),
});

export const {
	useLoadAddressQuery,
	useGetProvinceQuery,
	useDeleteAddressMutation,
	useCreateAddressMutation,
	useUpdateAddressMutation,
	useLazyGetRegionWithSelectQuery,
} = addressApiSlice;
